'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import { FlipCard } from '../flip-card';
import { Icon } from '../icon';
import type { IconButtonProps } from './IconButton.types';

import styles from './IconButton.module.scss';

export function IconButton({
  style,
  className,
  icon,
  flipped,
  flipIcon,
  loading = false,
  size = 'md',
  testId = 'ui-icon-button',
  ref,
  ...rest
}: IconButtonProps & { ref?: Ref<HTMLButtonElement> }) {
  const disabled = rest.disabled || loading;

  return (
    <button
      ref={ref}
      style={style}
      className={classnames(
        styles['icon'],
        disabled && !loading && styles[`icon--disabled`],
        loading && styles[`icon--fading`],
        className,
      )}
      data-testid={testId}
      type="button"
      {...rest}
      disabled={disabled}
    >
      {flipIcon ? (
        <FlipCard
          className={classnames(size && styles[`flip-card--${size}`])}
          direction="horizontal"
          flipped={flipped}
          disabled={rest.disabled}
          frontChildren={<Icon icon={icon} size={size} />}
          backChildren={<Icon icon={flipIcon} size={size} />}
        />
      ) : (
        <Icon icon={icon} size={size} />
      )}
    </button>
  );
}
